import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { ElementName } from '../../../../../constants';
import { useFlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { BaseIconElement, toLinkIconProps } from '../common';
var LinkIconElement = function LinkIconElement(props) {
  var context = useFlexibleUiContext();
  if (!context) {
    return null;
  }
  var data = toLinkIconProps(context === null || context === void 0 ? void 0 : context.linkIcon, context.type);
  return data ? /*#__PURE__*/React.createElement(BaseIconElement, _extends({}, data, props, {
    name: ElementName.LinkIcon
  })) : null;
};
export default LinkIconElement;